module.exports = __webpack_public_path__ + "static/media/corporate-services-img25.7f9f49a4.jpg";